import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { formatIstCustom } from '../../../../utils/helpers/istDate';

const fmtDateTime = (value) => {
    if (!value) return '—';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    return formatIstCustom(d, {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
    });
};

const browserDetails = (row) => {
    const parts = [row?.browser, row?.platform].filter(Boolean);
    return parts.length ? parts.join(' / ') : '—';
};

const TYPE_COLORS = {
    'Super Admin': 'tw-bg-rose-50 tw-text-rose-600',
    'Society Admin': 'tw-bg-indigo-50 tw-text-indigo-600',
    'Tenant': 'tw-bg-amber-50 tw-text-amber-600',
    'Employee': 'tw-bg-emerald-50 tw-text-emerald-600',
    'Occupant': 'tw-bg-blue-50 tw-text-blue-600',
};

const TypePill = ({ value }) => {
    const cls = TYPE_COLORS[value] || 'tw-bg-gray-50 tw-text-gray-600';
    return (
        <span className={`tw-inline-block tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium ${cls}`}>
            {value || '—'}
        </span>
    );
};

const LastTransactionOne = ({ recentActivity = [] }) => {
    const rows = Array.isArray(recentActivity) ? recentActivity : [];

    return (
        <div className="col-xxl-6">
            <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden h-100 tw-flex tw-flex-col">
                <div className="tw-px-4 tw-py-3 tw-border-b tw-border-gray-100 tw-flex tw-items-center tw-justify-between">
                    <h6 className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-0">Recent Activity</h6>
                    <Link to="#" className="tw-text-xs tw-text-rose-600 hover:tw-text-rose-700 tw-flex tw-items-center tw-gap-1 tw-no-underline">
                        View All <Icon icon="solar:alt-arrow-right-linear" />
                    </Link>
                </div>
                <div className="tw-overflow-x-auto tw-flex-1">
                    <table className="tw-w-full tw-text-xs">
                        <thead>
                            <tr className="tw-bg-gradient-to-r tw-from-slate-50 tw-to-gray-50">
                                <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">User</th>
                                <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Type</th>
                                <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Device</th>
                                <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">When</th>
                            </tr>
                        </thead>
                        <tbody className="tw-divide-y tw-divide-gray-50">
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={4} className="tw-text-center tw-text-gray-400 tw-py-6">
                                        No recent activity
                                    </td>
                                </tr>
                            ) : rows.map((r) => (
                                <tr key={r.id} className="hover:tw-bg-slate-50/50 tw-transition-colors">
                                    <td className="tw-px-4 tw-py-2.5">
                                        <div className="tw-font-medium tw-text-gray-800">{r.user_name || '—'}</div>
                                        <div className="tw-text-[10px] tw-text-gray-400 tw-font-mono">#{r.user_id}</div>
                                    </td>
                                    <td className="tw-px-4 tw-py-2.5"><TypePill value={r.user_type} /></td>
                                    <td className="tw-px-4 tw-py-2.5">
                                        <div className="tw-text-gray-700">{r.mobile_brand || browserDetails(r)}</div>
                                        {r.mobile_brand && (r.browser || r.platform) ? (
                                            <div className="tw-text-[10px] tw-text-gray-400">{browserDetails(r)}</div>
                                        ) : null}
                                    </td>
                                    <td className="tw-px-4 tw-py-2.5 tw-text-gray-500 tw-whitespace-nowrap">{fmtDateTime(r.at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default LastTransactionOne;
